import { render, staticRenderFns } from "./Facturaciones.vue?vue&type=template&id=7edc7a8a&"
import script from "./Facturaciones.vue?vue&type=script&lang=ts&"
export * from "./Facturaciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports